import script from "./traffic-trend-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./traffic-trend-chart.vue?vue&type=script&lang=ts&setup=true"

import "./traffic-trend-chart.vue?vue&type=style&index=0&id=8fd3defa&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fd3defa"]])

export default __exports__